export default "__VITE_ASSET__d5e3b4b2__"